module.exports = __webpack_public_path__ + "75.png";